import React, { useEffect, useReducer, useRef, useState } from 'react'
import { useLogger } from '../../../contexts/logger.context'
import { useKey } from 'react-use'
import { useAtom } from 'jotai'
import {
  bookingSessionDepartureDisponibilidad, bookingSessionDepartureSelectedTickets, bookingSessionTripConfig, bookingSessionDepartureBlockedTickets,
  bookingSessionFares,
  bookingSessionCountFares,
  bookingSessionReturningTrip,
  TranspaisIDToken
} from '../../../utilities/atoms'
import { isEmpty } from 'lodash'

import { useModal } from '../../../contexts/modal.context'

import Keyboard from 'react-simple-keyboard'
// import PlacesViewSection from './PlacesViewSection'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Button } from '../../../components/transpais'

import styles from './PassengerView.module.scss'
import { PassengerType, TicketService, TripAmenity, TripType } from '../../../components/transpais/enums'
import { currency } from '../../../components/transpais/helpers/currency'
import { isSingleTrip, isSelectingRoundTripDeparture, isRoundTripReturn, filterFares } from '../../../helpers/tripHelpers'
import { decodeToken } from '../../../utilities/token'



const PassengerView = ({seat, disponibilidad, onFinish, departure, selected, listsPassengers, updatedList, fareList, countFares, noPets, referencia, noPetsWindow, fromoduleReserv}) => {
  const [, forceUpdate] = useReducer(x => x + 1, 0)

  const keyboard = useRef()
  const [keyboardLayout, setKeyboardLayout] = useState('default')

  const [indexSelected, setIndexSelected] = useState(null)
  
  const [showScreenKeyboard, setShowScreenKeyboard] = useState(false)
  const [name, setName] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [selectedPassenger, setSelectedPassenger] = useState('')

  const {loggerDebug} = useLogger()
  const [selectedServices, setSelectedServices] = useState([])
  const [bookingTripConfig, setBookingTripConfig] = useAtom(bookingSessionTripConfig)
  const [bookingDepartureBlockedTickets, setBookingDepartureBlockedTickets] = useAtom(bookingSessionDepartureBlockedTickets)
  const [disabled, setDisabled] = useState(true)
  const [emptyPassenger, setEmptyPassenger] = useState({})
  const [defaultPrice, setDefaultPrice] = useState(null)
  const [price, setPrice] = useState(null)
  const inputRef = useRef(null)
  const cursorPosition = useRef(0)
  const enableCursor = useRef(false)
  const [bookingReturningTrip] = useAtom(bookingSessionReturningTrip)

  // Validar si se deben mostrar los bloques
  const shouldShowPassengerBlocks = isSingleTrip(bookingTripConfig) || (isSelectingRoundTripDeparture(bookingTripConfig, bookingDepartureBlockedTickets, fareList) && seat.type !== 'return')
  const shouldShowReturnPassengerBlocks = isRoundTripReturn(bookingTripConfig, bookingReturningTrip)
  const [selectedFare, setSelectedFare] = useState(null)
  const inputLastNameRef = useRef(null)
  const [cursorPositions, setCursorPositions] = useState({
    name: 0,
    lastName: 0
  })
  const [activeInput, setActiveInput] = useState('name')
  const [transpaisIDToken,] = useAtom(TranspaisIDToken)

  function capitalizeWords(name) {
    return name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
  }

  const handleNameClick = () => {
    console.log('inputRef', inputRef)
    const pos = inputRef.current.selectionStart
    setCursorPositions(prev => ({...prev, name: pos}))
  }
  
  const handleLastNameClick = () => {
    console.log('inputLastNameRef', inputLastNameRef)
    const pos = inputLastNameRef.current.selectionStart
    setCursorPositions(prev => ({...prev, lastName: pos}))
  }

  const setCodeKey = (key) => {
    if (key !== 'Enter' && !(key.includes('{') && key.includes('}'))) {
      if (activeInput === 'name') {
        enableCursor.current ? setKeyPosition(key, name, setName) : setName(name + key)
      } else {
        enableCursor.current ? setKeyPosition(key, lastName, setLastName) : setLastName(lastName + key)
      }
    } else if (key === '{at}') {
      if (activeInput === 'name') {
        enableCursor.current ? setKeyPosition('@', name, setName) : setName(name + '@')
      } else {
        enableCursor.current ? setKeyPosition('@', lastName, setLastName) : setLastName(lastName + '@')
      }
    } else if (key === '{space}') {
      if (activeInput === 'name') {
        enableCursor.current ? setKeyPosition(' ', name, setName) : setName(name + ' ')
      } else {
        enableCursor.current ? setKeyPosition(' ', lastName, setLastName) : setLastName(lastName + ' ')
      }
    } else if (key === '{dotcom}') {
      if (activeInput === 'name') {
        enableCursor.current ? setKeyPosition('.com', name, setName) : setName(name + '.com')
      } else {
        enableCursor.current ? setKeyPosition('.com', lastName, setLastName) : setLastName(lastName + '.com')
      }
    }
  }

  function onKeyboardKeyPress(button) {
    loggerDebug('Button pressed', button)

    const insertAccentedLetter = (letter, currentValue, setValue) => {
      if (enableCursor.current) {
        setValue(
          currentValue.slice(0, cursorPosition.current) +
            letter +
            currentValue.slice(cursorPosition.current)
        )
        cursorPosition.current = cursorPosition.current + 1
      } else {
        setValue(currentValue + letter)
      }
    }

    if (button === '{esc}') {
      setShowScreenKeyboard(false)
    } else if (button === '{bksp}') {
      if (activeInput === 'name') {
        if (enableCursor.current) {
          if (cursorPosition.current > 0) {
            setName(name.slice(0, cursorPosition.current - 1) + name.slice(cursorPosition.current))
            cursorPosition.current = cursorPosition.current - 1
          }
        } else {
          setName(name.slice(0, -1))
        }
      } else {
        if (enableCursor.current) {
          if (cursorPosition.current > 0) {
            setLastName(lastName.slice(0, cursorPosition.current - 1) + lastName.slice(cursorPosition.current))
            cursorPosition.current = cursorPosition.current - 1
          }
        } else {
          setLastName(lastName.slice(0, -1))
        }
      }
    } else if (button === '{shift}' || button === '{lock}') {
      handleShift()
    } else {
      switch (button) {
        case 'á':
        case 'é':
        case 'í':
        case 'ó':
        case 'ú':
          if (activeInput === 'name') {
            insertAccentedLetter(button, name, setName)
          } else {
            insertAccentedLetter(button, lastName, setLastName)
          }
          break
        default:
          setCodeKey(button)
      }
    }
  }

  function setKeyPosition(key, currentValue, setValue) {
    let newValue = currentValue.substring(0, cursorPosition.current) + key + currentValue.substring(cursorPosition.current)
    let increment = key === '.com' ? 4 : 1
    cursorPosition.current = cursorPosition.current + increment
    setValue(newValue)
  }

  function handleShift() {
    loggerDebug(keyboard.current)
    const newLayoutName = keyboardLayout === 'default' ? 'shift' : 'default'
    setKeyboardLayout(newLayoutName)
  }

  const handlePassengerSelection = (passenger, index) => {
    // Notificar al componente padre sobre el pasajero seleccionado
    onFinish({
      ...passenger,
      selectedIndex: index,
    })
  }

  const showPassengers = () => {
    // Filtrar pasajeros que no tengan un asiento de tipo "return"
    const passengersWithoutReturnSeat = selected.filter(
      (passenger) => !passenger.seats.some((seat) => seat.type === "return")
    )
    return passengersWithoutReturnSeat.map((passenger, index) => (
      <div
        key={`passenger_${index}`}
        onClick={() => handlePassengerSelection(passenger, index)}
        className={[
          styles.option,
          selectedPassenger === index ? styles.selected : null,
          passenger.seatReturn ? styles.blockedSeat : null,
        ].join(' ')}
      >
        <div>
          <FontAwesomeIcon icon={PassengerType.icon(passenger.fare)} className={styles.icon} />
        </div>
        <div className={[styles.description, styles.defaultPassenger].join(' ')}>
          <h2>
            {`${passenger.firstName} ${passenger.lastName}`.length <= 15
              ? `${passenger.firstName} ${passenger.lastName}`
              : `${`${passenger.firstName} ${passenger.lastName}`.slice(0, 15)}...`}
          </h2>
          <p>{passenger.fare}</p>
        </div>
      </div>
    ))
  }
  
  // Filtrar fares que aún tengan cupos disponibles
  const [filteredFares, setFilteredFares] = useState([])

  const handleSubmit = () => {
    const fareData = fareList.find((fare) => fare._id === selectedFare)
    const userTs = decodeToken(transpaisIDToken)
    onFinish({
      firstName: name,
      lastName: lastName,
      email: userTs.email,
      fareId: selectedFare,
      fare: fareData.name,
      // fareData,
    })
  }
  
  useEffect(() => {
    // Función para filtrar la lista estática
    const filterFares = () => {
      // Crear un objeto para contar cuántos pasajeros hay por fareId
      const passengerCount = selected.reduce((acc, passenger) => {
        if (passenger.fareId) {
          acc[passenger.fareId] = (acc[passenger.fareId] || 0) + 1
        }
        return acc
      }, {})

      // Filtrar la lista estática
      const filtered = fareList.filter((fare) => {
        // Verificar si el fareId está en la configuración
        if (countFares.hasOwnProperty(fare._id)) {
          // Obtener la cantidad máxima permitida desde la configuración
          const maxQuantity = countFares[fare._id]
          // Obtener la cantidad actual de pasajeros registrados para este fareId
          const currentQuantity = passengerCount[fare._id] || 0
          // Mostrar solo si aún no se ha alcanzado la cantidad máxima
          return currentQuantity < maxQuantity
        }
        return false // Si no está en la configuración, no se muestra
      })
      setFilteredFares(filtered)
    }

    filterFares()
  }, [fareList, countFares, selected]) // Dependencias del useEffect

  useEffect(() => {
    if(!isEmpty(name)){
      setName(capitalizeWords(name))
    }
    if (!name || !lastName || !selectedFare) {
      setLastName(capitalizeWords(lastName))
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [name, lastName, selectedFare])//,selectedDisponibilidad

  useEffect(() =>{ 
    console.log(selectedServices)
  }, [selectedServices])

  useEffect(() => {
    //TODO: validar que si es redondo y se esta seleccionando el viaje de regreso sera necesario seleccionar el fare automatico
    //Se utiliza para la seleccion automatica en tipo de pasajero
    if (filteredFares.length >= 1) {
      setSelectedFare(filteredFares[0]._id)
    }

    if (shouldShowReturnPassengerBlocks) {
      // Si estamos en el viaje de regreso, seleccionamos el primer pasajero
      const passengersWithoutReturnSeat = selected.filter(
      (passenger) => !passenger.seats.some((seat) => seat.type === "return")
      )

      // TODO: Revisar si es necesario seleccionar el primer pasajero automaticamente
      if (passengersWithoutReturnSeat.length > 0) {
        // const firstPassenger = passengersWithoutReturnSeat[0]
        // handlePassengerSelection(firstPassenger, 0)
      }
    }
  }, [filteredFares])

  return (
    <div className={ [styles.passengerView].join(' ') }>
      
      {shouldShowPassengerBlocks && (
        <>
          {/* Bloque para nombre y apellido */}
          <div className={styles.namePassenger}>
            <div>
              <h1 className={styles.seat}>
                <span>Asiento</span>
                {seat?.seatNumber}
              </h1>
            </div>
            <div className={styles.data}>
              <h2>Nombre y apellido</h2>
              <div className={styles.inputs}>
                <input 
                type="text" 
                placeholder="Nombre" 
                value={name} 
                ref={inputRef} 
                onClick={handleNameClick}
                onFocus={() => {
                  setShowScreenKeyboard(true)
                  setActiveInput('name')
                }}
                onChange={(e) => setName(e.target.value)}
                />
                <input 
                type="text" 
                placeholder="Apellido" 
                value={lastName}
                ref={inputLastNameRef}
                onClick={handleLastNameClick}
                onFocus={() => {
                  setShowScreenKeyboard(true)
                  setActiveInput('lastName')
                }}
                onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Bloque para tipo de pasajero */}
          <section className={styles.optionsSection}>
            <h2>Tipo de pasajero</h2>
            <div className={styles.options}>
              {fareList.map((fare) => (
                <div key={`cat_${fare._id}`} className={styles.optionWrapper}>
                  <div
                    onClick={() => setSelectedFare(fare._id)}
                    className={[styles.option, selectedFare === fare._id ? styles.selected : null].join(' ')}
                  >
                    <div>
                      <FontAwesomeIcon icon={PassengerType.icon(fare.indexableName)} className={styles.icon} />
                    </div>
                    <div className={styles.description}>
                      <h2>{fare.name}</h2>
                    </div>
                    <div className={styles.cost}>
                      <h2>{'$' + fare.displayCurrencyValue}</h2>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {selectedPassenger && (
              <div className={styles.alert}>
                <p>
                  {fareList.find((fare) => fare._id === selectedPassenger)
                    ? `${fareList.find((fare) => fare._id === selectedPassenger).name}: ${fareList.find((fare) => fare._id === selectedPassenger).disclaimer}`
                    : ''}
                </p>
              </div>
            )}
          </section>
        </>
      )}

       {/* Bloques para viaje redondo (regreso) */}
       {shouldShowReturnPassengerBlocks && (
        <>
          <div className={styles.namePassenger}>
            <div className={styles.seatRound}>
              <h1 className={[styles.seat, styles.seatPassenger].join(' ')}>
                <span>Asiento</span>
                {seat?.seatNumber}
              </h1>
            </div>
          </div>
          <section className={[styles.optionsSection, !isEmpty(emptyPassenger[selectedPassenger]) ? styles.messagePassenger : ''].join(' ')}>
            <div className={styles.options}>{showPassengers()}</div>
            {!isEmpty(emptyPassenger[selectedPassenger]) ? (
              <div className={styles.messagePassenger}>
                <p>
                  Esta corrida no tiene disponibilidad para "{emptyPassenger[selectedPassenger]}" por lo que tu boleto será de adulto.
                </p>
              </div>
            ) : (
              ''
            )}
          </section>
        </>
      )}

      <footer className={ styles.bottom }>
        <Button disabled={ disabled } type="positive" right-icon="chevron-right" onClick={ handleSubmit }>Continuar</Button>
      </footer>

      <div className={ [styles.keyboardWrapper, showScreenKeyboard ? styles.keyboardShown : null].join(' ') }>
        <Keyboard keyboardRef={ r => (keyboard.current = r) }
          //onChange={onKeyboardChange}
                  onKeyPress={ onKeyboardKeyPress }
                  layoutName={ keyboardLayout }
                  layout={ {
                    default: [
                      '{esc} 1 2 3 4 5 6 7 8 9 0 {bksp}',
                      '{blank} q w e r t y u i o p',
                      '{lock} a s d f g h j k l \u00f1 {blank}',
                      '{shift} z x c v b n m á é í ó ú . - {shift}',
                      '{space} {at} {dotcom}',
                    ],
                    shift: [
                      '{esc} 1 2 3 4 5 6 7 8 9 0 {bksp}',
                      'Q W E R T Y U I O P \u0308',
                      '{lock} A S D F G H J K L Ñ {blank}',
                      '{shift} {blank} Z X C V B N M Á É Í Ó Ú _ {shift}',
                      '{space} {at} {dotcom}',
                    ],
                  } }
                  display={ {
                    '{at}': `<svg class="key-icon"><use xlink:Href="#at"/></svg>`,
                    '{bksp}': `<svg class="key-icon"><use xlink:Href="#delete-left"/></svg>`,
                    '{esc}': `<svg class="key-icon"><use xlink:Href="#keyboard-down"/></svg>`,
                    '{blank}': ` `,
                    '{space}': ` `,
                    '{lock}': `<svg class="key-icon"><use xlink:Href="#font-case"/></svg>`,
                    '{shift}': `<svg class="key-icon"><use xlink:Href="#up"/></svg>`,
                    '{dotcom}': `.com`,
                  } }
        />
      </div>
    </div>
  )

}
export default PassengerView